<template>
  <div ref="recaptcha" />
</template>

<script>
export default {
  name: "NotARobotButton",
  mounted() {
    window.grecaptcha.render(this.$refs.recaptcha, {
      sitekey: this.$recaptchaKey,
      callback: (value) => {
        this.$emit('input', value);
      },
    });
  },
}
</script>
